import { useMicRecorder } from "../../hooks/use-mic-recorder";
import { useToast } from "../../hooks/use-toast";
import { useEffect } from "react";
import Logo from "../../static/icons/icon_mic_muted.svg";

export const NoSoundWarningBanner = () => {
  const { soundDetected, isRecording, defaultAudioDevice } = useMicRecorder();

  const { failureToast, dismissToasts } = useToast();

  useEffect(() => {
    if (isRecording && !soundDetected) {
      failureToast(
        `No audio detected. Make sure your microphone "${defaultAudioDevice.label}" is not muted.`,
        {
          position: "top-center",
          icon: <img src={Logo} />
        }
      );
    } else {
      dismissToasts();
    }
  }, [isRecording, soundDetected]);

  return <></>;
};
